














import { Vue, Prop, Component } from 'vue-property-decorator';
import { IStop } from '../api/stops';
import { IRoute } from '../api/routes';

import { convertTime } from './stop-timetable-helpers';

@Component({
  filters: {
    convertTime
  }
})
export default class StopTimetable extends Vue {
  // Route Id to show
  @Prop({
    type: String,
    required: true
  })
  readonly routeId!: string;

  // Stop to display
  @Prop({
    type: Object,
    required: true
  })
  readonly stop!: IStop;

  /**
   * Get the times for this stop at this route
   */
  get times() {
    return this.stop.schedule[this.routeId];
  }
}
